export default __webpack_public_path__ + "static/media/microphone.0d51e10c.svg";